import { getWeatherIcon as getWeatherIconUtil } from '../../utils/weatherUtils';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  background-color: var(--weather-bg);
  .weatherWeek {
    width: 100%;
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 0.5rem;
    gap: 0.25rem;
    padding: 0 0.5rem;
    /* padding: 0 0.75rem; */
    margin: 1rem 0;
    margin: 0.75rem 0;
    .weatherDay {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: var(--weather-sub-bg);
      color: var(--alpha-25);
      color: var(--board);
      border-radius: 1rem;
      border-radius: 0.5rem;
      overflow: hidden;
      &.large {
        > .dayTitle {
          padding-top: 0.5rem;
          .day {
            font-size: 1rem;
          }
          .date {
            font-size: 1.125rem;
            padding-top: 0.5rem;
          }
        }

        > .temp {
          gap: 1rem;
          padding: 1rem 0;

          > .data-wrapper {
            font-size: 1rem;
          }
        }
      }

      &:not(.red) {
        color: #fff;
      }
      &.red {
        color: var(--tonal-light-red);
        // color: var(--tonal-deep-red);
      }
      &.blue {
        color: var(--tonal-light-blue);
        // color: var(--tonal-deep-blue);
      }
      .dayTitle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 0.5rem;
        width: 100%;
        * {
          line-height: 1.25;
        }
        .day {
          font-size: 0.75rem;
          font-weight: 500;
          padding-top: 0.375rem;
          padding-top: 0.5rem;
          width: 100%;
          text-align: center;
        }
        .date {
          font-size: 0.875rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 2rem;
          min-width: 2.5rem;
        }
      }
      .icon {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 0.25rem;
        margin: 0 0.5rem;
        margin-bottom: 0.5rem;
        min-width: 3rem;
        width: 40%;
      }
      .temp {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
        padding: 0.25rem 0;
        width: 100%;
        background-color: var(--weather-sub-bg-2);
        border-radius: 0.5rem;
        .data-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.125rem;
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--text-primary);
          /* color: var(--board); */
          padding-right: 0.25rem;
          .unit {
            font-size: 0.75rem;
            font-weight: 500;
            color: var(--text-tertiary);
            /* color: var(--alpha-50); */
            /* color: var(--alpha-75); */
          }
          .material-symbols-rounded {
            font-size: 1.125rem;
            font-size: 1rem;
            font-variation-settings: 'FILL' 1, 'wght' 600;
            &.lowest {
              color: var(--filled-blue-deep);
              /* color: var(--tonal-deep-blue); */
            }
            &.highest {
              color: var(--filled-red);
              /* color: var(--tonal-deep-red); */
            }
          }
        }
      }
    }
  }
`;

const getWeatherIconComponent = (weather: string) => {
  return getWeatherIconUtil(weather, 48);
};

interface Props {
  after6Days: IDays[];
  size: 'small' | 'large';
}

const WeatherTotalWeek = ({ after6Days, size = 'small' }: Props) => {
  const { t } = useTranslation();

  return (
    <Root className='large'>
      <div className='weatherWeek'>
        {after6Days.map(({ date, day, maxTemp, minTemp, sky }: IDays) => {
          return (
            <div
              key={date} //
              className={`weatherDay ${day === '토' ? 'blue' : ''} ${day === '일' ? 'red' : ''} ${size}`}
            >
              <div className='dayTitle'>
                <div className='day'>{t(day)}</div>
                <div className='date'>{date}</div>
              </div>
              <div className='icon'>{getWeatherIconComponent(sky)}</div>
              <div className='temp'>
                <div className='data-wrapper'>
                  <span className='material-symbols-rounded lowest'>arrow_downward</span>
                  {minTemp}
                  <span className='unit'>°</span>
                </div>
                <div className='data-wrapper'>
                  <span className='material-symbols-rounded highest'>arrow_upward</span>
                  {maxTemp}
                  <span className='unit'>°</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Root>
  );
};

export default WeatherTotalWeek;
